<div class="d-flex flex-row align-items-center ml-3 mr-3">
    <app-content-header [historyBack]="false" (backEvent)="onBack()"
        [headline]="'integration-apps-creation-editor_headline' | i18next"></app-content-header>
</div>

<div class="ml-3 mr-3">
    <p-accordion [(value)]="activeAccordionPanels" [multiple]="true">
        <p-accordion-panel #appInformationPanel value="0">
            <p-accordion-header>{{ 'integration-apps-creation-editor_app_information_tab' | i18next
                }}</p-accordion-header>
            <p-accordion-content>
                <app-integration-app-information-form
                    [formGroup]="appInformationForm">
                </app-integration-app-information-form>
            </p-accordion-content>
        </p-accordion-panel>
        <br>
        <p-accordion-panel #apiPermissionPanel value="1">
            <p-accordion-header>{{ 'integration-apps-creation-editor_api_permissions_tab' | i18next }}</p-accordion-header>
            <p-accordion-content>
              <div class="d-flex flex-row flex-wrap">
                <span>{{ 'integration-apps-creation-editor_api_permissions_doc_link_description' | i18next }}
                  <a class="text-nowrap" target="_blank" [href]="apiDocsUrl">{{ apiDocsUrl }}</a>
                </span>
              </div>
              <app-list-select
                [availableListName]="'integration-apps-creation-editor_available_permissions_header'"
                [selectedListName]="'integration-apps-creation-editor_selected_permissions_header'"
                [disabled]="false"
                [availableItemsList]="availablePermissions"
                [selectedItemsList]="selectedPermissions"
                (selectedItemsListChange)="onPermissionsChange($event)">
              </app-list-select>
            </p-accordion-content>
        </p-accordion-panel>
        <br>
        <p-accordion-panel #instanceProvisioningPanel value="2">
            <p-accordion-header>{{ 'integration-apps-creation-editor_instance_provisioning_tab' | i18next
                }}</p-accordion-header>
            <p-accordion-content>
                <app-data-table
                  [columns]="columns"
                  [data]="instanceProvisioningEntryList">
                  <ng-template #rowTemplate let-row let-columns="columns">
                    <tr>
                      <td>
                        <p-chip class="justify-content-center" [label]="getTypeLabelKey(row.type) | i18next"
                          style="padding-top: 0px; padding-bottom: 0px; min-width: 100px; border-radius: 5px;"/>
                      </td>
                      <td>{{ getUninstallLabelKey(row.onUninstall) | i18next }}</td>
                      <td>{{ row.key }}</td>
                      <td>
                        <div class="d-flex flex-row justify-content-end">
                          <i class="fa fa-edit red hover-effect" (click)="onEditProvisioningEntry(row)"></i>
                          <i class="fa fa-trash red hover-effect ml-3" (click)="openDeleteConfirmDialog(row.id)"></i>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </app-data-table>
                <div class="d-flex justify-content-end mt-3">
                  <button class="btn btn-outline-primary mr-3" (click)="onAddProvisioningEntry()">{{ 'integration-apps-creation-editor_add_label_btn' | i18next }}</button>
                </div>
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
    <div class="d-flex justify-content-end mt-3">
      @if (isInEditMode) {
        <button class="btn btn-outline-primary mr-3" (click)="createNewIntegrationAppVersion()">{{ 'integration-apps-creation-editor_create_new_version_button_text' | i18next }}</button>
      } @else {
        <button class="btn btn-outline-primary mr-3" (click)="createIntegrationApp()">{{ 'integration-apps-creation-editor_create_new_app_button_text' | i18next }}</button>
      }
    </div>
</div>

<app-integration-apps-instance-provisioning-dialog [(showDialog)]="showDialog" (addEntry)="onProvisioningEntryAdded($event)" 
  [entryToEdit]="editProvisioningEntry" [(dialogContent)]="dialogContentType">
</app-integration-apps-instance-provisioning-dialog>

<p-confirmDialog></p-confirmDialog>